import { get, getAll } from '@bigyouth/base'
import smoothscroll from 'smoothscroll-polyfill'

/**
 * Scroll to the targeted element passed by props.
 *
 * Props:
 * target(string, required): selector of the targetted element.
 * targetIndex(int, optional): index of the target you want to scroll to.
 *   A getAll with this.props.target will be done if targetIndex is specified.
 *   Then the [targetIndex] of the targets will be selected.
 */
export default {
  name: 'scroll-to',

  events: [
    {
      on: 'click',
      handle (e) {
        if (this.target) {
          e.preventDefault()
          if (this.offset) {
            const bodyRect = document.body.getBoundingClientRect().top
            const elementRect = this.target.getBoundingClientRect().top
            const elementPosition = elementRect - bodyRect
            const offsetPosition = elementPosition - this.offset
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            })
          } else {
            this.target.scrollIntoView({ block: 'start', behavior: 'smooth' })
          }
        }
      },
    },
  ],

  componentDidMount () {
    if (this.props.targetIndex) {
      this.target = getAll(this.props.target)[this.props.targetIndex]
    } else {
      this.target = get(this.props.target)
    }

    if (this.props.offset) {
      this.offset = this.props.offset
      smoothscroll.polyfill()
    }
  },
}
